// extracted by mini-css-extract-plugin
export default {"button":"Button_button__UY+OE","warn":"Button_warn__8Mwkr","button--outline":"Button_button--outline__vapxb"};